<!--
 * @Author: Yran
 * @Date: 2021-05-31 13:53:38
 * @LastEditors: Yran
 * @LastEditTime: 2021-06-17 14:36:59
-->
<template>
  <div class="update_notification w100 h100 bcg_w">
    <a-timeline>
      <a-timeline-item v-for="(item, index) in updateInfo" :key="index" :color="index === 0 ? 'green' : 'gray'">
        <div class="title cursorPoi" @click="getCollapse(index) ? setCollapse(index, 'del') : setCollapse(index, 'add')">
          <span class="time">{{ item.time }}</span>
          <span class="label">{{ item.label }}</span>
          <CaretDownOutlined v-if="getCollapse(index)" />
          <CaretUpOutlined v-else />
        </div>
        <div class="content">
          <ul class="content-list font16" :class="{ collapse: getCollapse(index) }">
            <li v-for="(content, key) in item.contentList" :key="key">{{ content }}</li>
          </ul>
        </div>
      </a-timeline-item>
    </a-timeline>
  </div>
</template>
<script>
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons-vue';
export default {
  data() {
    return {
      activeKeyList: [],
      updateInfo: [
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
        {
          time: '2021-05-31',
          label: '客户管理更新',
          contentList: ['1.更新客户管理', '2.新增产品管理'],
        },
      ],
    };
  },
  components: { CaretUpOutlined, CaretDownOutlined },
  mounted() {
    this.updateInfo.forEach((item, index) => {
      if (index !== 0) {
        this.activeKeyList.push(index);
      }
    });
  },
  methods: {
    /** 处理时间轴是否折叠
     * @param {Number} index 索引
     * @param {String} type 新增||删除 标识
     * @return {*}
     */
    setCollapse(index, type) {
      if (type === 'add') {
        this.activeKeyList.push(index);
        this.activeKeyList = Array.from(new Set(this.activeKeyList));
      } else {
        this.activeKeyList = this.activeKeyList.filter(item => {
          return item !== index;
        });
      }
    },
    /** 判断当前索引是否在折叠数组中
     * @param {Number} index 索引
     * @return {*}
     */
    getCollapse(index) {
      return this.activeKeyList.indexOf(index) !== -1;
    },
  },
};
</script>
<style lang="less" scoped>
.update_notification {
  padding: 12px;
  border-radius: 8px;
  .title {
    .time,
    .label {
      font-size: 0.6rem;
      font-weight: bold;
    }
    .label {
      padding-left: 1rem;
      padding-right: 0.2rem;
    }
  }
  .content-list {
    &.collapse {
      height: 0;
      overflow-y: hidden;
    }
    & > li {
      height: 1rem;
      line-height: 1rem;
    }
  }
}
</style>